import { render, staticRenderFns } from "./ShareCustomerManagerDialog.vue?vue&type=template&id=c4f91656&scoped=true"
import script from "./ShareCustomerManagerDialog.vue?vue&type=script&lang=js"
export * from "./ShareCustomerManagerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f91656",
  null
  
)

export default component.exports